import SearchHintsMainPage from '../home/HeroHome/SearchHintsMainPage'

import { Container, Content, Wrapper } from './HomeHeroWrapper.styled'

interface Props {
  children: React.ReactNode
  withoutContent?: boolean
  className?: string
  noPadding?: boolean
}

function HomeHeroWrapper(props: Props) {
  const { children, withoutContent, className, noPadding = false } = props

  return (
    <Container className={className}>
      <Wrapper noPadding={noPadding}>
        {!withoutContent ? <Content>{children}</Content> : children}
      </Wrapper>
      <SearchHintsMainPage />
    </Container>
  )
}

export default HomeHeroWrapper
